import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

import type { AuthSliceAuthState } from '../../../../types/core.component-props.types';
const initialState: AuthSliceAuthState = {
    me: null,
    token: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ me: any; token: string | null }>) => {
            state.me = action.payload.me;
            state.token = action.payload.token;

            if (action.payload.token) {
                Cookies.set('accessToken', action.payload.token);
            } else {
                Cookies.remove('accessToken');
            }
        },
        logout: (state) => {
            state.me = null;
            state.token = null;
            Cookies.remove('accessToken');
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
